"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var Tree_1 = require("./Tree");
var ModelVersionComponent = /** @class */ (function (_super) {
    __extends(ModelVersionComponent, _super);
    function ModelVersionComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.getModelVersion = function () {
            var modelVersion = "";
            if (_this.props.interaction) {
                modelVersion = _this.props.interaction.modelVersion;
            }
            return modelVersion;
        };
        _this.state = {};
        return _this;
    }
    ModelVersionComponent.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Model version: ", this.getModelVersion()] }) }));
    };
    ModelVersionComponent = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], ModelVersionComponent);
    return ModelVersionComponent;
}(React.Component));
exports.default = ModelVersionComponent;
//# sourceMappingURL=ModelVersionComponent.js.map